module.exports = __webpack_public_path__ + "img/adas-hil-5.78a54ff1.svg";